import { signOutFromNewsletter, signUpToNewsletter } from './api'
import { NewsletterFormType } from './types'

interface HandleNewsletterConsentChangeParams {
  value: boolean
  email: string
  formType?: NewsletterFormType
}

export const handleNewsletterConsentChange = async ({
  value,
  email,
  formType
}: HandleNewsletterConsentChangeParams) => {
  return value
    ? signUpToNewsletter({ email, formType })
    : signOutFromNewsletter({ email })
}
